import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { RichText } from '../Common/TextEditor/TextEditor';
import GroupSelector from '../Common/GroupSelector/GroupSelector';
import ColorPicker from '../Common/ColorPicker';
import ContentPicker from '../Common/ContentPicker';
import TextField from '@material-ui/core/TextField';
import { IconButton } from '@projeccions-pdc/react-icon';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import AskConfirmationModal from '../Common/AskConfirmationModal';
import { cloneDeep } from 'lodash';
import { getLocalizedName } from '../../helpers';
import NotificationService from '../../apiclients/NotificationService';
import AppContext from '../../AppContext';
import Loader from '../Common/Loader';
import LocalizedStrings from '../Localization/localization';
import ReadLogs from './ReadLogs';
import './notifications.css';

class NotificationDetail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isContentPickerOpen: false,
            anchorEl: null,
            askOpen: false,
            notification: {
                content: '',
                color: '#a1a1a1',
                dateCreated: undefined,
                dateUpdated: undefined,
                groupId: undefined,
                notificationId: undefined,
                // platformId: this.props.platformId,
                status: 'editable',
                title: '',
                version: -1,
                attachments: [],
            },
        };
    }

    goBack = () => {
        if (this.props.history) {
            this.props.history.push('/notifications/');
        }
        if (this.props.finished) {
            this.props.finished();
        }
    };

    async componentDidMount() {
        if (this.props.isNew === undefined) {
            let notificationId = this.props.match.params.notificationId;
            if (notificationId !== 'new') {
                this.setState({ loading: true });
                let noti = await NotificationService.getNotification(notificationId);
                if (!noti.attachments) {
                    noti.attachments = [];
                }
                this.setState({ notification: noti, loading: false });
            }
        } else {
            // console.log('new', this.props.resource);
            let resource = this.props.resource;
            let resourceType, resourceSubtype, resourceId, names;
            if (resource.contentId !== undefined) {
                resourceId = resource.contentId;
                resourceType = 'content';
                resourceSubtype = resource.objectType;
                names = resource.names;
            } else {
                resourceId = resource.fileId;
                resourceType = 'file';
                resourceSubtype = resource.fileType;
                names = { default: resource.filename };
            }
            let language = new AppContext().getLanguage();
            let currName = getLocalizedName(language, names);

            this.setState({
                notification: {
                    title: LocalizedStrings.contentUpdate,
                    content: `${LocalizedStrings.theContent} "${currName}" ${LocalizedStrings.updated}`,
                    color: '#a1a1a1',
                    dateCreated: undefined,
                    dateUpdated: undefined,
                    groupId: resource.groupId,
                    notificationId: undefined,
                    // platformId: this.props.platformId,
                    status: 'editable',
                    version: -1,
                    attachments: [
                        {
                            names: names,
                            resourceId: resourceId,
                            resourceSubtype: resourceSubtype,
                            resourceType: resourceType,
                        },
                    ],
                },
            });
        }
    }

    handleTitleChange = (evt) => {
        let newNoti = Object.assign({}, this.state.notification);
        newNoti.title = evt.target.value;
        this.setState({ notification: newNoti });
    };

    handleColorChange = (color) => {
        let newNoti = Object.assign({}, this.state.notification);
        newNoti.color = color;
        this.setState({ notification: newNoti }, () => this.updateNoti());
    };

    onGroupSelected = (groupId) => {
        let newNoti = Object.assign({}, this.state.notification);
        newNoti.groupId = groupId;
        this.setState({ notification: newNoti }, () => this.updateNoti());
    };

    handleContentChange = (slot, newName) => {
        let newNoti = Object.assign({}, this.state.notification);
        newNoti.content = newName;
        this.setState({ notification: newNoti }, () => this.updateNoti());
    };

    onAttachmentsChange = (newAttachents) => {
        // console.log('datachange', newAttachents);
        let newNoti = cloneDeep(this.state.notification);
        newNoti.attachments = newAttachents;
        this.setState({ notification: newNoti }, () => this.updateNoti());
    };

    handleAddContentClick = (event) => {
        this.setState({ isContentPickerOpen: true });
    };

    handleCloseContentPicker = () => {
        this.setState({ isContentPickerOpen: false });
    };

    updateNoti = async () => {
        if (this.state.notification.notificationId) {
            try {
                this.toastUpdateId = this.props.notify('info', 'updating notification...', this.toastUpdateId);
                let updated = await NotificationService.updateTitleAndContent(
                    this.state.notification.notificationId,
                    this.state.notification.title,
                    this.state.notification.content,
                    this.state.notification.color,
                    this.state.notification.attachments
                );
                //console.log('updated', updated);
                this.setState({ notification: updated });
                this.toastUpdateId = this.props.notify('success', 'updated!', this.toastUpdateId);
            } catch (err) {
                console.log(err);
            }
        }
    };

    onCreateClick = () => {
        this.setState({ askOpen: true });
    };

    onDeleteClick = async () => {
        try {
            this.toastDeleteId = this.props.notify('info', 'deleting notification...', this.toastDeleteId);
            await NotificationService.deleteNotification(this.state.notification.notificationId);
            this.goBack();
            this.toastDeleteId = this.props.notify('success', 'deleted!', this.toastDeleteId);
        } catch (err) {
            console.log(err);
        }
    };

    closeAsk = () => {
        this.setState({ askOpen: false });
    };

    onAskConfirmationResponse = async (response) => {
        try {
            this.closeAsk();
            this.toastCreateId = this.props.notify('info', 'creating notification...', this.toastCreateId);
            let updated = await NotificationService.newNotification(
                this.state.notification.groupId,
                this.state.notification.title,
                this.state.notification.content,
                this.state.notification.color,
                this.state.notification.attachments
            );
            this.toastCreateId = this.props.notify('success', 'created!', this.toastCreateId);
            this.setState({ notification: updated }, async () => {
                if (response === true) {
                    //SEND
                    try {
                        await NotificationService.sendNotification(this.state.notification.notificationId);
                        this.toastCreateId = this.props.notify('success', 'Notification sent!', this.toastCreateId);
                    } catch (err) {
                        console.log(err);
                        this.toastCreateId = this.props.notify('error', 'Error sending notification', this.toastCreateId);
                    }
                }
                this.goBack();
            });
        } catch (err) {
            console.log(err);
            this.toastCreateId = this.props.notify('error', 'Error creating the notification', this.toastCreateId);
        }
    };

    render() {
        let isEditable = true;
        if (this.state.notification) {
            isEditable = this.state.notification.status === 'editable' ? true : false;
        }

        let appContext = new AppContext();
        let platformId = appContext.getPlatformId();

        let richTextStyle = {
            border: `1px solid ${isEditable ? '#000' : '#a5a5a5'}`,
            borderRadius: '2px',
            marginTop: '10px',
            marginBottom: '10px',
            paddingLeft: '10px',
            paddingRight: '10px',
            color: isEditable ? '#000' : '#a5a5a5',
        };
        let fieldStyle = {
            display: 'inline-block',
            maxWidth: '80%',
        };

        let labelStyle = {
            display: 'inline-block',
            margin: '10px 5px',
        };

        if (this.state.loading === true) {
            return (
                // <div style={{ textAlign: 'center', marginTop: '15px' }}>
                <div className="pdc-notification-loadingContainer">
                    <Loader loading={true} size={'90px'} />
                </div>
            );
        }

        return (
            <div>
                {this.state.notification && (
                    <div>
                        <div style={labelStyle}>{'Title:'}</div>
                        <TextField
                            id="title"
                            label="Add title"
                            value={this.state.notification.title}
                            onChange={this.handleTitleChange}
                            onBlur={this.updateNoti}
                            margin="normal"
                            disabled={!isEditable}
                            style={{ width: '400px' }}
                        />
                        <br />

                        <div style={labelStyle}>{'Color:'}</div>
                        <ColorPicker
                            disabled={!isEditable}
                            color={this.state.notification.color}
                            handleColorChange={this.handleColorChange}
                        />
                        <br />

                        <div style={labelStyle}>{'Visibility:'}</div>
                        <div style={fieldStyle}>
                            <GroupSelector
                                onGroupSelected={this.onGroupSelected}
                                selectedGroup={this.state.notification.groupId}
                                removeGroup={() => this.onGroupSelected(undefined)}
                                disabled={!isEditable}
                            />
                        </div>

                        <br />

                        <div style={labelStyle}>{'Content:'}</div>
                        {isEditable ? (
                            <RichText
                                style={richTextStyle}
                                slot="notificationContent"
                                placeholder={'Notification Content'}
                                simpleMode={false}
                                content={this.state.notification.content}
                                onChange={this.handleContentChange}
                            />
                        ) : (
                            <div dangerouslySetInnerHTML={{ __html: this.state.notification.content }} style={richTextStyle} />
                        )}
                        <br />

                        <div style={labelStyle}>{'Attachments:'}</div>
                        {isEditable && <IconButton name="fa-plus" onClick={this.handleAddContentClick} />}
                        {/* {console.log(this.state.notification.attachments)} */}
                        <Dialog
                            fullWidth
                            maxWidth="md"
                            open={this.state.isContentPickerOpen}
                            onClose={this.handleCloseContentPicker}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{'Attachments'}</DialogTitle>
                            <DialogContent>
                                <ContentPicker
                                    notify={this.props.notify}
                                    onDataChange={this.onAttachmentsChange}
                                    contents={this.state.notification.attachments}
                                    disabled={!isEditable}
                                />
                            </DialogContent>
                            <DialogActions>
                                <Button variant="contained" onClick={this.handleCloseContentPicker}>
                                    {'Done'}
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <ContentPicker
                            platformId={platformId}
                            notify={this.props.notify}
                            onDataChange={this.onAttachmentsChange}
                            contents={this.state.notification.attachments}
                            disabled={true}
                        />
                        <br />
                        {isEditable === false && <ReadLogs notification={this.state.notification} />}
                        <br />
                        <div style={{ textAlign: 'right' }}>
                            {this.state.notification.notificationId === undefined && (
                                <Button variant="outlined" onClick={this.onCreateClick}>
                                    {'Create'}
                                </Button>
                            )}
                            {this.state.notification.notificationId !== undefined && isEditable && (
                                <Button variant="outlined" onClick={this.onDeleteClick}>
                                    {'Delete'}
                                </Button>
                            )}
                        </div>
                    </div>
                )}
                <AskConfirmationModal
                    isOpen={this.state.askOpen}
                    closeModal={this.closeAsk}
                    title={'Creating Notification'}
                    question={'Do you want to send the notification once it is created? or only create it?'}
                    positiveOption={'Create & Send'}
                    negativeOption={'Create'}
                    onAskConfirmationResponse={this.onAskConfirmationResponse}
                />
            </div>
        );
    }
}
NotificationDetail.propTypes = {
    isNew: PropTypes.bool,
    match: PropTypes.object,
    history: PropTypes.object,
    notify: PropTypes.func.isRequired,
    resource: PropTypes.object,
    finished: PropTypes.func,
};

export default NotificationDetail;
